var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownvoteBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0607 13.0607C12.4749 13.6464 11.5251 13.6464 10.9393 13.0607L1.3934 3.51472C0.807612 2.92893 0.807612 1.97918 1.3934 1.3934C1.97918 0.807612 2.92893 0.807612 3.51472 1.3934L12 9.87868L20.4853 1.3934C21.0711 0.807612 22.0208 0.807612 22.6066 1.3934C23.1924 1.97918 23.1924 2.92893 22.6066 3.51472L13.0607 13.0607ZM13.5 10.5V12H10.5V10.5H13.5Z",
    fill: "#5891E6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownvoteBlue);
export default __webpack_public_path__ + "static/media/DownvoteBlue.8240c93974825bdc760bf57a611fe8ab.svg";
export { ForwardRef as ReactComponent };